import type { Configuration } from '@ui/features/configurator/types';

import { coldHeadedFastenerConfiguration } from './cold-headed-fastener';

type SiteConfiguration = Record<string, Configuration[]>;

export const siteConfigurations: SiteConfiguration = {
  ADF: [coldHeadedFastenerConfiguration],
  ROC: [coldHeadedFastenerConfiguration],
  USA: [],
};
